var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("featured-offers", {
    attrs: {
      settings: _vm.settings,
      blocks: _vm.blocks,
      modalOpen: _vm.modalOpen
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }